import {Component, ElementRef, Input, OnInit, ViewEncapsulation} from '@angular/core';

import {
  CanColor,
  mixinColor,
  ThemePalette
} from '../core';

const BUTTON_HOST_ATTRIBUTES = [
  'cyb-button',
  'cyb-icon-button'
];

// Boilerplate for applying mixins to MatButton.
export class CybButtonBase {
  constructor(public _elementRef: ElementRef) {}
}

export const _CybButtonMixinBase = mixinColor(CybButtonBase);

@Component({
  selector: 'button[cyb-button], button[cyb-icon-button]',
  template: `<span class="cyb-button-wrapper"><ng-content></ng-content></span>
`,
  styles: [`.cyb-button{display:inline-block;height:35px;border:none;font-size:1rem;font-weight:400;line-height:1.4;border-radius:2px;padding:7px 15px;transition:all .12s linear;width:100%;max-width:170px;min-width:95px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:Telefonica;outline:0}.cyb-button:hover{background-position:right 0 top 0;background-size:auto 800%;box-shadow:0 1px 4px rgba(0,0,0,.3);text-shadow:0 0 1px #fff;color:#fff;border:0;outline:0;text-decoration:none}.cyb-icon-button{display:inline-block;min-width:70px;text-align:left;position:relative;padding:7px 40px 7px 15px;height:35px;border:none;font-size:1rem;font-weight:400;line-height:1.4;border-radius:2px;transition:all .12s linear;width:100%;max-width:170px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;vertical-align:middle;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-transform:none;margin:0;box-sizing:border-box;font-family:Telefonica;outline:0}.cyb-icon-button i{position:absolute;right:10px;margin:2px 0 0}.material-icons{font-size:1.2rem;font-weight:400;font-style:normal;display:inline-block;width:1em;height:1em;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;vertical-align:text-bottom;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-feature-settings:'liga';font-feature-settings:'liga';overflow:visible}.cyb-primary{color:#fff;background-image:linear-gradient(#6ebb80 0,#096 100%);background-position:left 0 top 0;background-size:auto 100%}.cyb-latch{color:#fff;background-image:linear-gradient(#05d3d3 0,#00b9be 100%);background-position:left 0 top 0;background-size:auto 100%}.cyb-cancel{color:#fff;background-image:linear-gradient(#df0615 0,#bb1621 100%);background-position:left 0 top 0;background-size:auto 100%}.cyb-secondary{color:#fff;background-image:linear-gradient(#0395a7 0,#015366 100%);background-position:left 0 top 0;background-size:auto 100%}.cyb-grey{color:#808487;background-image:linear-gradient(#f6f6f6 0,#c9c9c9 100%);background-position:right 0 top 0;background-size:auto 200%;box-shadow:0 1px 2px rgba(0,0,0,.3);text-shadow:0 1px 0 #fff}.cyb-grey:hover{color:#808487}`],
  inputs: ['color'],
  encapsulation: ViewEncapsulation.None,
})

export class ButtonComponent extends _CybButtonMixinBase
  implements CanColor {

  constructor(elementRef: ElementRef) {
    super(elementRef);

    // For each of the variant selectors that is prevent in the button's host
    // attributes, add the correct corresponding class.
    for (const attr of BUTTON_HOST_ATTRIBUTES) {
      if (this._hasHostAttributes(attr)) {
        (elementRef.nativeElement as HTMLElement).classList.add(attr);
      }
    }
  }

  /** Focuses the button. */
  focus(): void {
    this._getHostElement().focus();
  }

  _getHostElement() {
    return this._elementRef.nativeElement;
  }

  /** Gets whether the button has one of the given attributes. */
  _hasHostAttributes(...attributes: string[]) {
    return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
  }
}
